(function () {
    'use-strict';

    var inputs = document.querySelectorAll(
        '#meilisearch-predictive-input-desktop, #meilisearch-predictive-input-mobile'
    );
    var resultsContainer = document.getElementById('meilisearch-predictive-results');
    if (!inputs || !resultsContainer) return;

    var config = window.MeilisearchPredictiveConfig;
    if (!config) return;

    var HOST = config.host;
    var API_KEY = config.apiKey;
    var INDEX = config.index;
    var showOutOfStock = config.showOutOfStock !== false;
    var locale = config.locale || 'de';
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var debounceTimer = null;
    var abortController = null;
   
    function closeDropdown() {
        resultsContainer.style.display = 'none';
        resultsContainer.innerHTML = '';
        clearTimeout(debounceTimer);
        if (abortController) abortController.abort();
    }

    var closeButtons = document.querySelectorAll('.search-modal__close-button');
    closeButtons.forEach(function (btn) {
        btn.addEventListener('click', closeDropdown);
    });

    document.addEventListener('click', function (e) {
        var desktopWrapper = document.querySelector('.header_search_desktop');
        var mobileWrapper = document.querySelector('.header_search_mobile');
        var isInside =
            (desktopWrapper && desktopWrapper.contains(e.target)) ||
            (mobileWrapper && mobileWrapper.contains(e.target)) ||
            resultsContainer.contains(e.target);
        if (!isInside) closeDropdown();
    });

    inputs.forEach(function (input) {
        input.addEventListener('input', function () {
            clearTimeout(debounceTimer);
            var query = input.value.trim();

            if (!query) {
                resultsContainer.style.display = 'none';
                resultsContainer.innerHTML = '';
                return;
            }

            debounceTimer = setTimeout(function () {
                searchProducts(query);
            }, 300);
        });

        input.addEventListener('click', function () {
            input.value = '';
            closeDropdown();
        });

        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
            e.preventDefault();
            var query = input.value.trim();
            if (query) {
                window.location.href = rootPath + 'search?q=' + encodeURIComponent(query);
            }
            }
        });
    });
   
    function searchProducts(query) {
        if (abortController) abortController.abort();
        abortController = new AbortController();

        var searchQuery = { indexUid: INDEX, q: query, limit: 16, sort: ['filter_score:desc'] };
        if (!showOutOfStock) {
            searchQuery.filter = '(totalInventory > 0 OR variants.inventoryPolicy = "CONTINUE")';
        }

        fetch(HOST + '/multi-search', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + API_KEY
            },
            body: JSON.stringify({ queries: [searchQuery] }),
            signal: abortController.signal,
        })
        .then(response => {
            if (!response.ok) throw new Error('Meilisearch ' + response.status);
            return response.json();
        })
        .then(data => {
            var hits = data.results && data.results[0] ? data.results[0].hits : [];
            renderResults(hits);
        })
        .catch(error => {
            if (error.name !== 'AbortError') {
                console.error("Error searching for products: ", error);
            }
        });
    }

    function renderResults(hits) {
        if (!hits.length) {
            resultsContainer.innerHTML = '<p>' + (config.noResultsMessage || 'Keine Ergebnisse gefunden.') + '</p>';
            resultsContainer.style.display = 'block';
            return;
        }

        resultsContainer.innerHTML = hits.map(renderHit).join('');
        resultsContainer.style.display = 'block';
    }

    function formatPrice(amount) {
        if (amount == null || amount === '') return '';
        var num = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
        if (isNaN(num)) return '';
        var isWhole = num % 1 === 0;
        var decimals = isWhole ? 0 : 2;
        var parts = num.toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
        return parts.join('.') + (isWhole ? '.-' : '');
    }

    var PREDICTIVE_SRCSET_WIDTHS = [120, 240, 360];

    function shopifyImageUrl(src, width) {
        if (!src) return src;
        var sep = src.indexOf('?') !== -1 ? '&' : '?';
        return src + sep + 'width=' + width;
    }

    function shopifySrcset(src) {
        if (!src) return '';
        return PREDICTIVE_SRCSET_WIDTHS
            .map(function (w) { return shopifyImageUrl(src, w) + ' ' + w + 'w'; })
            .join(', ');
    }

    function getImageSrc(hit) {
        if (hit.images && hit.images.length) {
            var img = hit.images[0];
            var src = typeof img === 'string' ? img : (img.src || img.url || '');
            return src || '';
        }
        return '';
    }

    function renderHit(hit) {
        var localizedHandle = hit['handle_' + locale] || hit.handle || '';
        var url = rootPath + 'products/' + localizedHandle;
        var title = hit.title || 'Produkt';
        var imgSrc = getImageSrc(hit);
        var currency = (hit.price && hit.price.currency) || 'CHF';
        var price = (hit.price && parseFloat(hit.price.minPrice)) || 0;
        var compareAt = (hit.variants && hit.variants[0] && parseFloat(hit.variants[0].compareAtPrice)) || 0;
        var isSale = compareAt > 0 && compareAt > price;

        var priceHtml = '';
        if (isSale) {
            priceHtml =
                '<span class="ms-predictive-price ms-predictive-price--sale">' + formatPrice(price) + '</span>' +
                ' <span class="ms-predictive-price--compare"><span class="ms-statt-label">' + (locale === 'fr' ? 'au lieu de' : 'statt') + '</span>' + formatPrice(compareAt) + '</span>';
        } else {
            priceHtml = '<span class="ms-predictive-price">' + formatPrice(price) + '</span>';
        }

        return (
            '<a href="' + url + '" class="ms-predictive-hit">' +
                '<div class="ms-predictive-hit__image">' +
                    (imgSrc ? '<img src="' + shopifyImageUrl(imgSrc, 120) + '" srcset="' + shopifySrcset(imgSrc) + '" sizes="60px" alt="' + title + '" loading="lazy">' : '<img src="https://aico.apps.aico.swiss/images/no-images.png" alt="' + title + '" loading="lazy">') +
                '</div>' +
                '<div class="ms-predictive-hit__info">' +
                    '<span class="ms-predictive-hit__title">' + title + '</span>' +
                    '<div class="ms-predictive-hit__price">' + priceHtml + '</div>' +
                '</div>' +
            '</a>'
        );
    }
})();